/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Selectattempt1Inputs */

const zh_learn_selectattempt1 = /** @type {(inputs: Learn_Selectattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一条作答记录查看详情`)
};

const en_learn_selectattempt1 = /** @type {(inputs: Learn_Selectattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an attempt to view details`)
};

const es_learn_selectattempt1 = /** @type {(inputs: Learn_Selectattempt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un intento para ver los detalles`)
};

/**
* | output |
* | --- |
* | "Select an attempt to view details" |
*
* @param {Learn_Selectattempt1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_selectattempt1 = /** @type {((inputs?: Learn_Selectattempt1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Selectattempt1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_selectattempt1(inputs)
	if (locale === "en") return en_learn_selectattempt1(inputs)
	return es_learn_selectattempt1(inputs)
});
export { learn_selectattempt1 as "learn_selectAttempt" }